import PropTypes from 'prop-types';
import { Container, Hidden } from '@material-ui/core';

import useLocalized from 'CustomHooks/useLocalized';
import VehicleHireIcon from 'UI/Screens/Main/Sections/Services/Assets/VehicleHireIcon';
import BookDriverForm from 'UI/Screens/Main/Sections/Header/Blocks/BookDriverForm/BookDriverForm';
import ImagePresenter from 'UI/Components/ImagePresenter/ImagePresenter';
import VehicleElement from 'UI/Screens/Services/Blocks/VehicleElement/VehicleElement';
import { VehicleHireBackground, leyland_daf, vauxhall_movano } from 'UI/Screens/Services/Assets';
import { useGetVehicleContent, useGetVehiclePartnerContent } from "../../../Data/ApiHooks/UseContentHook";

const VehicleHireScreen = ({
  branchLocationOptions,
}) => {

  const { data: vehicleData } = useGetVehicleContent();
  const { data: vehiclePartnerData } = useGetVehiclePartnerContent();

  return (
    <>
      <div className="service-detail-screen">
        <Container className="service-detail-screen__container">
          <div className="service-detail-screen__left">
            <div className="service-detail-screen__left--title">
              {vehicleData?.vehicle_service_title}
              <VehicleHireIcon className="service-detail-screen__left--title--icon" />
            </div>
            <div className="service-detail-screen__left--description">
              {vehicleData?.vehicle_description}
            </div>

            <div className="service-detail-screen__left--content">
              {vehiclePartnerData !== undefined && vehiclePartnerData.map(vehicle => <VehicleElement key={vehicle.id} vehicle={vehicle} />)}
            </div>
            <div className="service-detail-screen__left--sub-description">
              {useLocalized('not_include_vat')}
            </div>
          </div>
          <div className="service-detail-screen__right">
            <BookDriverForm branchLocationOptions={branchLocationOptions} className="service-detail-screen__right--form" />
          </div>
        </Container>
        <div className="service-detail-screen-background-layer">
          <div className="service-detail-screen-background-layer__left"></div>
          <div className="service-detail-screen-background-layer__right" style={{ backgroundImage: `url(${VehicleHireBackground})` }}/>
        </div>
        <Hidden mdUp>
          <ImagePresenter
            containerClass="service-detail-screen__mobile-image-container"
            imageClass="service-detail-screen__mobile-image-container--image"
            src={VehicleHireBackground}
          />
        </Hidden>
      </div>
    </>
  );
}

VehicleHireScreen.propTypes = {
  branchLocationOptions: PropTypes.object,
};

export default VehicleHireScreen;
